import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'deviceManagementExperience.devicePositionsExport'

const DeviceManagementDevicePositionsExportSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default DeviceManagementDevicePositionsExportSlice
